
import "./TemplateEditor.less";

import { Modal, Spin } from "antd";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { ComponentTemplateApi, EntryGroupTemplateApi, ListingGroupTemplateApi } from "lib/api";
import { CancellationToken } from "lib/api/base";
import { IBaseProps } from "lib/data/interfaces";
import { ComponentTemplate, EntryGroupTemplate, ListingGroupTemplate } from "lib/data/model";
import { ComponentNames } from "lib/data/model/dictionaries/ComponentNames";
import { IconType } from "lib/data/model/dictionaries/IconTypes";
import { StateService } from "lib/services";

import { TemplateCard } from "components/general";
import { actionTypes } from "components/general/TemplateCard/ActionTypes";
import { GenericTemplateSelectorSingle } from "../components/GenericTemplateSelector/GenericTemplateSelectorSingle";
import { NewSingleItemRequirement } from "../TemplateHierarchy/components/NewRequirement";

interface IMatchProps {
	id: string;
}

interface ITemplateEditorProps extends IBaseProps, RouteComponentProps<IMatchProps> {

}

export interface ITemplateEditorState {
	templateData: any;
	visibleSection: "template-selector" | "template-type" | "template-configuration";
	templateType: "Custom List" | "Personnel List" | null;
	templateName: string | null;
	iconType: string | null;
	newItemModalVisible: boolean;
	awaitingUpdate: boolean;
}


export class TemplateEditor extends React.Component<ITemplateEditorProps, ITemplateEditorState> {

	public static readonly BasePath: string = "/admin/templateeditor";

	public componentTemplates: ComponentTemplate[] = [];


	private apiCancellationToken: CancellationToken = new CancellationToken();

	public constructor(props: ITemplateEditorProps) {

		super(props);

		this.state = {
			templateData: [],
			visibleSection: "template-selector",
			templateType: null,
			templateName: null,
			iconType: null,
			newItemModalVisible: false,
			awaitingUpdate: false
		};
	}

	public componentWillMount = () => {
		this.setupComponentTemplates();
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	public setupComponentTemplates = async (callback?: () => void) => {
		this.componentTemplates = await ComponentTemplateApi.getComponentTemplates(true);
		if (callback) {
			callback();
		}
		this.forceUpdate();
	}

	public actionClick = (command: actionTypes, componentTemplate: ComponentTemplate) => {

		switch (command) {

			case "expand":

				this.props.history.push(`${TemplateEditor.BasePath}/${componentTemplate.$type}/${componentTemplate.id}`);
				break;

			default:
				break;
		}
	}

	public openModal = () => {
		StateService.setCancelableState(() => this.setState({ newItemModalVisible: true }), this.apiCancellationToken);
	}
	public closeModal = () => {
		StateService.setCancelableState(() => this.setState({ newItemModalVisible: false }), this.apiCancellationToken);
	}

	public templateSelected = async (template: ComponentTemplate) => {

		switch (template.$type) {

			case EntryGroupTemplate.$type:

				const entryGroupTemplate = template as EntryGroupTemplate;
				entryGroupTemplate.isReusable = true;
				StateService.setCancelableState(() => this.setState({ awaitingUpdate: true }), this.apiCancellationToken);
				await EntryGroupTemplateApi.save(entryGroupTemplate);
				this.setupComponentTemplates(() => {
					StateService.setCancelableState(() => this.setState({ awaitingUpdate: false, newItemModalVisible: false }), this.apiCancellationToken);
				});
				break;

			case ListingGroupTemplate.$type:

				const listingGroupTemplate = template as ListingGroupTemplate;
				listingGroupTemplate.isReusable = true;
				StateService.setCancelableState(() => this.setState({ awaitingUpdate: true }), this.apiCancellationToken);
				await ListingGroupTemplateApi.save(listingGroupTemplate);
				this.setupComponentTemplates(() => {
					StateService.setCancelableState(() => this.setState({ awaitingUpdate: false, newItemModalVisible: false }), this.apiCancellationToken);
				});
				break;

			default:
				break;
		}
	}
	public render() {

		// Render Normally
		return (
			// <Secure redirectOnDenial="/">
			<div className="template-editor">

				<Modal visible={this.state.newItemModalVisible} onCancel={this.closeModal}>
					{this.state.awaitingUpdate ?
						<Spin />
						:
						<GenericTemplateSelectorSingle noSectionTemplate={true} hideOptions={true} genericComponentTemplates={[]} templateSelected={this.templateSelected} />
					}
				</Modal>

				<NewSingleItemRequirement newSingleItemClick={this.openModal} />

				{this.componentTemplates.map((componentTemplate, key) => {

					switch (componentTemplate.$type) {

						case "EntryGroupTemplate":

							const entryGroupTemplate: EntryGroupTemplate = componentTemplate as EntryGroupTemplate;

							return (
								<TemplateCard
									className={"template-card"}
									key={key}
									actionButtonClick={(command) => this.actionClick(command, componentTemplate)}
									actionbuttons={["expand"]}
									border={true}
									showCheckboxes={false}
									title={entryGroupTemplate.name}
									iconType={IconType.get(entryGroupTemplate.$type)}
									templateType={ComponentNames[entryGroupTemplate.$type]}
								/>
							);

						case "ListingGroupTemplate":

							const listingGroupTemplate: ListingGroupTemplate = componentTemplate as ListingGroupTemplate;

							return (
								<TemplateCard
									className={"template-card"}
									key={key}
									actionButtonClick={(command) => this.actionClick(command, componentTemplate)}
									actionbuttons={["expand"]}
									border={true}
									showCheckboxes={false}
									title={listingGroupTemplate.name}
									iconType={IconType.get(listingGroupTemplate.$type)}
									templateType={ComponentNames[listingGroupTemplate.$type]}
								/>
							);

						default:
							break;
					}
					return null;
				})}

			</div>
			// </Secure>
		);
	}

	// private onSideBarButtonClick = () => {

	// }
}
